import React, { useEffect, useState } from 'react';
import { superAdminApi } from '../../api/client';
import StatCard from '../../components/common/StatCard';
import Spinner  from '../../components/common/Spinner';
import { FaSchool, FaUsers, FaChalkboardTeacher, FaGraduationCap } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function SuperDashboard() {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    superAdminApi.getStats().then(r => setStats(r.data.data)).catch(() => {});
  }, []);

  if (!stats) return <Spinner />;

  return (
    <div>
      <div className="page-header">
        <h2>Platform Overview</h2>
        <p>Monitor all schools registered on School SMS</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: 16, marginBottom: 28 }}>
        <StatCard label="Active Schools"    value={stats.active_schools}    icon={FaSchool}            color="#0d6efd" />
        <StatCard label="Suspended Schools" value={stats.suspended_schools} icon={FaSchool}            color="#ef4444" />
        <StatCard label="Total Learners"    value={stats.total_learners}    icon={FaGraduationCap}     color="#10b981" />
        <StatCard label="Total Teachers"    value={stats.total_teachers}    icon={FaChalkboardTeacher} color="#f59e0b" />
        <StatCard label="Total Users"       value={stats.total_users}       icon={FaUsers}             color="#8b5cf6" />
      </div>

      <div className="sms-card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h5 style={{ fontWeight: 600 }}>Recently Registered Schools</h5>
          <button className="sms-btn sms-btn-primary sms-btn-sm" onClick={() => navigate('/super-admin/schools')}>View All</button>
        </div>
        <table className="sms-table">
          <thead><tr><th>School</th><th>Slug</th><th>Status</th><th>Registered</th></tr></thead>
          <tbody>
            {stats.recent_schools?.map(s => (
              <tr key={s.school_id}>
                <td style={{ fontWeight: 500 }}>{s.name}</td>
                <td style={{ color: '#6b7280', fontFamily: 'monospace' }}>{s.slug}</td>
                <td><span className={`sms-badge ${s.status === 'active' ? 'badge-present' : 'badge-absent'}`}>{s.status}</span></td>
                <td style={{ color: '#6b7280', fontSize: '0.85rem' }}>{new Date(s.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
